import React from 'react';
import { Note } from '@saleshandy/icons';

const Notes = () => (
  <Note  className="orange-txt-16" />
);

export default Notes;
